import { MAX_PROFILE_LENGTH } from "../../modules/aml/aml.constant";

export interface FileValidationResults {
  noForbiddenCharacters: boolean;
  noLeadingWhitespace: boolean;
  noForbiddenFileNames: boolean;
  notExceededMaxLength: boolean;
}

export const regexForbiddenCharacters = /^[^$&+,:;=?@#|'<>.^*%!/]+$/;

export const validateFileName = (value: string): FileValidationResults => {
  const noForbiddenCharacters = (value: string): boolean =>
    regexForbiddenCharacters.test(value);

  const noLeadingWhitespace = (value: string): boolean => /^\S/.test(value);

  const noForbiddenFileNames = (value: string): boolean =>
    !/^(nul|prn|con|lpt\d|com\d)(\.|$)/i.test(value);

  const notExceededMaxLength = (value: string): boolean =>
    value.length < MAX_PROFILE_LENGTH;

  return {
    noForbiddenCharacters: noForbiddenCharacters(value),
    noLeadingWhitespace: noLeadingWhitespace(value),
    noForbiddenFileNames: noForbiddenFileNames(value),
    notExceededMaxLength: notExceededMaxLength(value),
  };
};

export const downloadFile = (fileUrl: string): void => {
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = "";
  link.click();
};
